import styled from 'styled-components';

const HeaderNewsHolder = styled.div`
  display: grid;
  grid-area: news;
  width: 100%;
  margin: 0 auto;
  background-color: black;
  font-family: "Open Sans", sans-serif;
  
  .break-news {
    margin-top: 3px;
    background-color: black;
    color: white;
    min-height: 84px;
    z-index: 13;
    background: black url(/static-assets/theme/svg/left-decoration.svg) top left no-repeat;
    padding: 1px 20px 10px 100px;
    display: flex;
    align-items: center;
    margin-left: 4px;
    margin-bottom: 3px;
    position:relative;
    @media only screen and (max-width: 767px) {
      padding: 1px 20px 10px 90px;
    }
    @media only screen and (max-width: 920px) {
      display: flex;
    }
    a {
      color: white;
      text-decoration: none;
      font-weight: 700;
      line-height: 25px;
      &:visited, &:hover {
        color: white;
        text-decoration: none; 
      }
    }
    img {
      display: inline-block;
      max-width: 40px;
      position: relative;
      top: -3px !important;
    }
    .fade-enter {
      opacity: 0.01;
    }
    .fade-enter.fade-enter-active {
      opacity: 1;
      transition: opacity 500ms ease-in;
    }

    .fade-leave {
      opacity: 1;
    }

    .fade-leave.fade-leave-active {
      opacity: 0.01;
      transition: opacity 300ms ease-in;
    }

    span{
      margin-top: 5px;
      display: inline-block;
      width: 80%;
      margin-right: auto;
    }
    .video-live-link {
      margin: 5px 20px 0px 0px;
      display: inline-block;
      font-weight: 700;
      z-index: 10;
      text-transform: uppercase;
      border-radius: 2px;
      color: black !important;
      background: white !important;
      padding: 2px 0px 2px 5px;
      font-size: 12px;
    }
    .video-live-label {
      position: relative;
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      border-radius: 2px;
      background: #FFF;
      color: black;
      text-align: left;
      vertical-align: top;
      line-height: 20px;
      min-height: auto !important;
      margin: 0;
      display: flex;
      align-items: center;
      margin-right: 5px;
      @media only screen and (max-width: 767px) {
        font-size: 16px;
        padding: 0px !important;
        color: red;
      }
      span {
        margin: 0px;
        width: 100%;
        @media only screen and (max-width: 767px) {
          margin: 2px;
        }
      }
      img {
        @media only screen and (max-width: 767px) {
          display: none;
        }
      }
    }
  }
`;

export default HeaderNewsHolder;